import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './components/navbar';
import FormComponent from './components/FormComponent';
import OrderSummaryPage from './components/orderSummary';
import OptionsPage from './components/ReshipesOptions';
import ThisWeeksOrders from './components/WeeksOrder';
import ProductQuantityNeeded from './components/ProductQuantity';
import LoginForm from './components/LoginForm';
import GetDeliveryAddresses from './components/DeliveryAddresses';
import NudgeCustomers from './components/NudgeCustomers';
import ProtectedPage from './components/ProtectedPage';


import CloseOrdersForWeek from './components/CloseOrders';
import OpenOrderForm from './components/OpenOrderForm';
import AddToOrder from './components/EditOrder';
import ManageMenu from './components/ManageMenu';
import AllOrders from './components/AllOrders';
import CustomerInfo from './components/CustomerInfo';
import FormClosed from './components/FormClosed';
import { AuthProvider, useAuth } from './components/AuthContext'; // Import AuthProvider and useAuth

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          {/* Customer-facing */}
          <Route path="/" element={<FormComponent />} />
          <Route path="/order-summary" element={<OrderSummaryPage />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/form-closed" element={<FormClosed />} />

          {/* Owner-only: every one of these calls an authenticated endpoint, so
              they must redirect to login once the token is gone or expired. */}
          {[
            ['/options', <OptionsPage />],
            ['/this-weeks-orders', <ThisWeeksOrders />],
            ['/product-quantity-needed', <ProductQuantityNeeded />],
            ['/delivery-addresses', <GetDeliveryAddresses />],
            ['/nudge-customers', <NudgeCustomers />],
            ['/close-orders', <CloseOrdersForWeek />],
            ['/open-orders', <OpenOrderForm />],
            ['/edit-order', <AddToOrder />],
            ['/manage-menu', <ManageMenu />],
            ['/all-orders', <AllOrders />],
            ['/customer-info', <CustomerInfo />],
            ['/protected', <ProtectedPage />],
          ].map(([path, element]) => (
            <Route key={path} path={path} element={<PrivateRoute>{element}</PrivateRoute>} />
          ))}
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
